import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import bemClassName from '../../utils/bem';
import { formatedDateRange, formattedDate } from '../../utils/date';
import { formatedType } from '../../utils/catalogUtils';

import './index.scss';
import { IApartamentPaymentProps } from './interface';

const apartamentPayment = bemClassName('apartament-payment');

const ApartamentPayment: React.FC<IApartamentPaymentProps> = ({
  data,
  cashback,
  total,
  begin,
  end,
  surcharge,
  discount,
  timeout,
  manager,
}) => {
  useEffect(() => {}, []);

  return data ? (
    <Link to={`/catalog/${data.city_name}/${data.id}/`} className={apartamentPayment('')}>
      <Swiper
        className={apartamentPayment('carousel')}
        spaceBetween={0}
        slidesPerView={1}
        modules={[Pagination]}
        pagination={{ clickable: true }}
        loop>
        {data.photos &&
          data.photos['298x298'] &&
          data.photos['298x298']?.slice(0, 5)?.map((_, index) => {
            const photoCount = data.photos!['298x298']?.length || 0;
            return (
              <SwiperSlide key={index}>
                <picture className={apartamentPayment('picture')}>
                  <source
                    media="(max-width: 720px)"
                    type="image/webp"
                    srcSet={`${data.photos?.['578x388'][index]} ${data.photos?.['1156x776'][index]} 2x, ${data.photos?.['1734x1164'][index]} 3x`}
                  />
                  <source
                    type="image/webp"
                    srcSet={`${data.photos?.['298x298'][index]} ${data.photos?.['596x596'][index]} 2x, ${data.photos?.['894x894'][index]} 3x`}
                  />
                  <img
                    className={apartamentPayment('image')}
                    src={`${data.photos?.['298x298'][index]}`}
                    srcSet={`${data.photos?.['596x596'][index]} ${data.photos?.['596x596'][index]} 2x, ${data.photos?.['894x894'][index]} 3x`}
                    alt=""
                  />
                </picture>
                {photoCount > 5 && index === 4 && (
                  <p className={apartamentPayment('last-slide-more')}>Ещё {photoCount - 5} фото</p>
                )}
              </SwiperSlide>
            );
          })}
      </Swiper>
      <div className={apartamentPayment('info')}>
        <div className={apartamentPayment('content')}>
          <p className={apartamentPayment('address')}>
            {formatedType(data.rooms!)} квартира, {data.address?.name}, {data.city?.name}
          </p>
          <p className={apartamentPayment('date')}>
            Даты бронирования: {formatedDateRange(begin!, end!)}
          </p>
          <div className={apartamentPayment('square')}>
            <p className={apartamentPayment('description', { full_width: true })}>
              {data.bedcode} спальных мест
            </p>
            <p className={apartamentPayment('description')}>
              {data.square} м<sup>2</sup> общая площадь
            </p>
          </div>
          {timeout && (
            <div>
              <p className={apartamentPayment('date')}>
                Бронь действительна до {formattedDate(timeout)} (мск)
              </p>
              <p className={apartamentPayment('description')}>
                Необходимо внести залог до этого времени.
              </p>
            </div>
          )}
          {manager && (
            <p className={apartamentPayment('number')}>
              Телефон менеджера: <span>{manager.phone}</span> ({manager.name})
            </p>
          )}
          {surcharge != null && Number(surcharge) > 0 && (
            <div>
              <p>Доплата: {surcharge}</p>
            </div>
          )}
          <div className={apartamentPayment('price')}>
            <div className={apartamentPayment('block')}>
              <p className={apartamentPayment('deposit')}>{data.deposit} ₽</p>
              <p className={apartamentPayment('sum-bottom')}>Залог</p>
            </div>
            {!cashback && discount != null && discount > 0 && (
              <div className={apartamentPayment('block')}>
                <p className={apartamentPayment('discount')}> {discount} ₽</p>
                <p className={apartamentPayment('sum-bottom')}>Cкидка</p>
              </div>
            )}
            {cashback && discount != null && discount > 0 && (
              <div className={apartamentPayment('block')}>
                <p className={apartamentPayment('cashback')}> {discount} ₽</p>
                <p className={apartamentPayment('sum-bottom')}>Кешбек</p>
              </div>
            )}
            <div className={apartamentPayment('block')}>
              <p className={apartamentPayment('total')}> {total} ₽</p>
              <p className={apartamentPayment('sum-bottom')}>Стоимость</p>
            </div>
          </div>
          <div className={apartamentPayment('price-mobile')}>
            {!cashback && (
              <div>
                <span className={apartamentPayment('sum-bottom')}>Cкидка</span>
                <span className={apartamentPayment('discount')}> {discount} ₽</span>
              </div>
            )}
            <div>
              {cashback}
              <span className={apartamentPayment('total-bottom')}>Итого</span>
              <span className={apartamentPayment('total')}> {total} ₽</span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  ) : (
    <p>Ошибка</p>
  );
};

export default ApartamentPayment;
